module.exports = __webpack_public_path__ + "static/img/abnormal.bbdfff87.png";